module.exports = new __parcel__URL__("buckley-classy.2e622e92.png").toString();